module.exports = __webpack_public_path__ + "static/media/배너 이용 방법 2.9a2d4395.jpg";